module.exports = __webpack_public_path__ + "img/interfolhas-mobile.a51b25b8.png";